import React, { useState, useEffect, useRef } from 'react'
import api from '../services/api'

interface Veiculo {
  veicod: string
  veipla: string
}

interface Props {
  onClose: () => void
  onSelect: (v: Veiculo) => void
}

export default function VeiculoModal({ onClose, onSelect }: Props) {
  const [lista, setLista] = useState<Veiculo[]>([])
  const [busca, setBusca] = useState('')
  const [carregando, setCarregando] = useState(true)
  const inputRef = useRef<HTMLInputElement>(null)
  const debounce = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    inputRef.current?.focus()
    carregar('')
  }, [])

  function carregar(texto: string) {
    setCarregando(true)
    api.get('/erp/veiculos', { params: texto ? { busca: texto } : {} })
      .then(r => setLista(r.data))
      .catch(() => setLista([]))
      .finally(() => setCarregando(false))
  }

  function handleBusca(v: string) {
    setBusca(v)
    if (debounce.current) clearTimeout(debounce.current)
    debounce.current = setTimeout(() => carregar(v), 300)
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" style={{ width: 420, maxHeight: '80vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Selecionar Veículo</h2>
          <button className="modal-fechar" onClick={onClose}>✕</button>
        </div>

        <div style={{ padding: '0.75rem 1rem 0.5rem' }}>
          <input
            ref={inputRef}
            type="text"
            placeholder="Buscar por placa ou prefixo..."
            value={busca}
            onChange={e => handleBusca(e.target.value)}
            style={{ width: '100%', boxSizing: 'border-box', padding: '0.4rem 0.6rem', border: '1.5px solid #d1d5db', borderRadius: '0.4rem', fontSize: '0.9rem' }}
          />
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '0 1rem 1rem' }}>
          {carregando ? (
            <p style={{ color: '#6b7280', textAlign: 'center', marginTop: '1rem' }}>Carregando...</p>
          ) : lista.length === 0 ? (
            <p style={{ color: '#6b7280', textAlign: 'center', marginTop: '1rem' }}>Nenhum veículo ativo encontrado.</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.88rem' }}>
              <thead>
                <tr style={{ background: '#f1f5f9' }}>
                  <th style={{ padding: '0.45rem 0.6rem', textAlign: 'left', borderBottom: '1px solid #e2e8f0', color: '#374151' }}>Prefixo</th>
                  <th style={{ padding: '0.45rem 0.6rem', textAlign: 'left', borderBottom: '1px solid #e2e8f0', color: '#374151' }}>Placa</th>
                </tr>
              </thead>
              <tbody>
                {lista.map(v => (
                  <tr
                    key={v.veicod}
                    onClick={() => onSelect(v)}
                    style={{ cursor: 'pointer', borderBottom: '1px solid #f1f5f9' }}
                    onMouseEnter={e => (e.currentTarget.style.background = '#eff6ff')}
                    onMouseLeave={e => (e.currentTarget.style.background = '')}
                  >
                    <td style={{ padding: '0.45rem 0.6rem', fontWeight: 600, color: '#1a6ea8' }}>{v.veicod}</td>
                    <td style={{ padding: '0.45rem 0.6rem' }}>{v.veipla}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  )
}
